
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/ui/logo';
import { AdSenseAd } from '@/components/ads/AdSenseAd';
import { useCookieConsent } from '@/contexts/CookieConsentContext';

export function Footer() {
  const { setShowPreferences } = useCookieConsent();

  React.useEffect(() => {
    const handleOpenSettings = () => {
      setShowPreferences(true);
    };
    
    window.addEventListener('openCookieSettings', handleOpenSettings);
    return () => window.removeEventListener('openCookieSettings', handleOpenSettings);
  }, [setShowPreferences]);

  return (
    <footer className="bg-muted text-muted-foreground">
      {/* AdSense Banner Before Footer */}
      <div className="w-full max-w-7xl mx-auto px-4 py-4">
        <AdSenseAd 
          slot="1122334455" // Replace with your actual ad slot ID
          format="horizontal"
          style={{ display: 'block', textAlign: 'center' }}
        />
      </div>
      
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1">
            <Logo className="h-8 w-auto" />
            <p className="mt-4 text-sm">
              Discover new destinations and plan your perfect trip with our travel guides and itineraries.
            </p>
          </div>
          <div className="col-span-1">
            <h3 className="text-sm font-medium">Discover</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/destinations" className="text-sm hover:text-foreground">
                  Destinations
                </Link>
              </li>
              <li>
                <Link to="/itineraries" className="text-sm hover:text-foreground">
                  Itineraries
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-foreground">
                  Travel Blog
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-sm hover:text-foreground">
                  Travel Products
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-1">
            <h3 className="text-sm font-medium">Legal</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-sm hover:text-foreground">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-sm hover:text-foreground">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const event = new CustomEvent('openCookieSettings');
                    window.dispatchEvent(event);
                  }}
                  className="text-sm hover:text-foreground text-left"
                >
                  Cookie Settings
                </button>
              </li>
              <li>
                <Link to="/privacy-policy#ccpa" className="text-sm hover:text-foreground">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-200 pt-8">
          <p className="text-sm text-center">
            &copy; {new Date().getFullYear()} Trotting the World. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
